import React from 'react';
import { 
  Box, 
  FormControl, 
  Select, 
  MenuItem, 
  InputLabel, 
  IconButton, 
  Tooltip,
  Chip,
  Stack
} from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

const CategoryFilter = ({ 
  categories, 
  selectedCategory, 
  onCategoryChange, 
  onRefresh,
  sx 
}) => {
  const handleCategoryClick = (category) => {
    onCategoryChange(category);
  };

  return (
    <Box sx={{ ...sx }}>
      {/* Category Chips - Show on desktop and mobile landscape */}
      <Stack 
        direction="row"
        spacing={2} 
        alignItems="center"
        justifyContent="space-between"
        sx={{
          display: {
            xs: 'none', // Hidden on mobile portrait
            sm: 'flex', // Show on tablet and up
            '@media (max-width:900px) and (orientation: landscape)': {
              display: 'flex', // Show on mobile landscape
            }
          }
        }}
      >
        {/* Category Chips */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, flex: 1 }}>
          {categories.map((category) => (
            <Chip
              key={category}
              label={category}
              variant={selectedCategory === category ? 'filled' : 'outlined'}
              color={selectedCategory === category ? 'primary' : 'default'}
              onClick={() => handleCategoryClick(category)}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: selectedCategory === category 
                    ? 'primary.dark' 
                    : 'action.hover',
                },
                transition: 'all 0.2s ease-in-out'
              }}
            />
          ))}
        </Box>

        {/* Refresh Button */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Tooltip title="Refresh documents" arrow>
            <IconButton 
              onClick={onRefresh}
              color="primary"
              sx={{
                '&:hover': {
                  backgroundColor: 'primary.light',
                  color: 'white'
                }
              }}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Stack>

      {/* Dropdown + Refresh Button - Show only on mobile portrait */}
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{
          display: {
            xs: 'flex', // Show on mobile portrait
            sm: 'none', // Hidden on tablet and up
            '@media (max-width:900px) and (orientation: landscape)': {
              display: 'none', // Hidden on mobile landscape
            }
          }
        }}
      >
        <FormControl fullWidth size="small">
          <InputLabel>Category</InputLabel>
          <Select
            value={selectedCategory}
            label="Category"
            onChange={(e) => onCategoryChange(e.target.value)}
          >
            {categories.map((category) => (
              <MenuItem key={category} value={category}>
                {category}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        
        <Tooltip title="Refresh documents" arrow>
          <IconButton 
            onClick={onRefresh}
            color="primary"
            sx={{
              flexShrink: 0,
              '&:hover': {
                backgroundColor: 'primary.light',
                color: 'white'
              }
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </Stack>
    </Box>
  );
};

export default CategoryFilter;
